export const ROUTES = {
  dashboard: '/',
  media: '/media',
  generatedMedia: '/generated-media',
  upload: '/media/new',
  campaignMediaUpload: '/media/campaign-upload',
  slides: '/slides/new',
  campaigns: '/campaigns',
  bookingsProblematic: '/problematic-bookings',
  campaignCreate: '/campaigns/new',
  forbidden: `/forbidden`,
};
